import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { ICopyProduct } from '../../../models/forms/ICopyProduct';
import { IFormModalProps } from '../../../models/forms/IForm';
import { formatMessage } from '../../../translations/format-message';
import CopyProductForm from '../forms/copy-product-form';

const CopyProduct = (props: IFormModalProps) => {
  const { productStore } = useStore();

  const { CopyProductService, copyProductState, resetCopyProductState } =
    productStore;
  const initialValues: ICopyProduct = {
    NewProductId: '',
    OldProductId: -1,
    TenantId: -1,
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (copyProductState.success) {
      toast.success(formatMessage('added_success'));
      props.modalClosed();
    }
  }, [copyProductState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (copyProductState.error) {
      toast.error(formatMessage(copyProductState.error));
      resetCopyProductState();
    }
  }, [copyProductState.error]);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = ({
    NewProductId,
    OldProductId,
    TenantId,
  }: ICopyProduct) => {
    const addObj: ICopyProduct = {
      NewProductId: NewProductId,
      OldProductId: props.id,
      TenantId: Number(getTenantIdFromLocalStorage()),
    };
    CopyProductService(addObj);
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetCopyProductState();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <CopyProductForm
        id={props.id}
        initialValues={initialValues}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        isLoading={copyProductState.inProgress}
      />
    </React.Fragment>
  );
};

export default observer(CopyProduct);
